// Venues page data with image requires
export function getVenuesData() {
  return {
    heroimg: {
      image: require("../assets/venue/venue-top.jpg")
     } ,
    heading: "Find Your Class at Studio V",
    subtitle: "Discover our fitness and martial arts programs designed to help you reach your \n full potential",
    description: "With certified instructors and dedicated zones for Taekwondo, Kickboxing-Muay Thai, Zumba, and high-impact fitness, we provide everything you need to train, grow, and succeed.",
    mainVenue: {
      name: "Studio V Fitness Centre",
      locationLabel: "Sungai Buloh",
      image: require("../assets/venue/venue-2.png"),
    },
    venues: [
      {
        id: 1,
        name: "SJK(C) KUANG",
        locationLabel: "Kuang, Sungai Buloh",
        image: require("../assets/venue/location-1.jpg")
      },
      {
        id: 2,
        name: "KLBC",
        locationLabel: "Bukit Bintang, Kuala Lumpur",
        image: require("../assets/venue/location-2.jpg")
      },
      {
        id: 3,
        name: "TIC TAC TOTS DAYCARE CENTRE",
        locationLabel: "North Kiara, Bukit Segambut",
        image: require("../assets/venue/location-3.jpg")
      }
    ]
  };
}

